var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone",style:(_vm.phoneStyle)},[(_vm.showPhoneNumber)?_c('span',[_vm._v(_vm._s(_vm.phone))]):_vm._e(),(_vm.phone)?_c('span',[_c('i',{directives:[{name:"role",rawName:"v-role",value:('web:call:flag'),expression:"'web:call:flag'"}],staticClass:"iconfont icondianhuabohao2x1 call-icon",on:{"click":_vm.webCall}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }